import { FC } from "react";
const ScrollableView: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({ children, ...rest }) => {
    return <div className={`${rest.className ?? ""} hide-scrollbar`} {...rest} >
        {children}
    </div>
}

export default ScrollableView;